import axios from "axios";
import { getApiBase } from "../apiBase";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders(extra = {}) {
  const h = { ...extra };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

export async function fetchCommercialReporting() {
  const { data } = await axios.get(`${getApiBase()}/reporting/commercial`, {
    headers: authHeaders(),
  });
  return data;
}
